import { DEFAULT_ERROR_MESSAGE } from 'shared/enums/ErrorMessage';
import { ErrorType } from 'shared/enums/ErrorType';

export class ResourceError extends Error {
  response: Error;

  constructor(response) {
    super(response);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ResourceError);
    }

    const message = response?.data?.messages?.[0] || DEFAULT_ERROR_MESSAGE;

    this.name = ErrorType.ResourceError;
    this.message = message;
    this.response = {
      ...response,
      name: ErrorType.ResourceError,
      message,
    };
  }
}
